export default "__VITE_ASSET__D9QAs3QU__"